import { createAction, props } from '@ngrx/store';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadProductCurrencies = createAction('[StaticData] Load ProductCurrencies');

export const loadProductCurrenciesSuccess = createAction(
  '[StaticData] Load ProductCurrencies Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadProductCurrenciesFailure = createAction('[StaticData] Load ProductCurrencies Failure', props<{ error: any }>());
